"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.btgSheetRequestSchema = exports.btgSheetContext = exports.PaymentBtgSheetSchema = void 0;
const zod_1 = require("zod");
const payment_config_types_1 = require("../payment.config.types");
const sheet_1 = require("./sheet");
const back_code_1 = require("./utils/back-code");
const validateCpf = zod_1.z
    .union([zod_1.z.string(), zod_1.z.number()])
    .transform(value => (typeof value === 'number' ? value.toString() : value)) // Converte números para strings
    .transform(str => str.replace(/[-.]/g, '')) // Remove '-' e '.'
    .refine(str => /^[0-9]{10,11}$/.test(str), {
    message: 'Deve conter apenas números e ter 10 ou 11 dígitos',
})
    .transform(str => (str.length === 10 ? '0' + str : str)) // Adiciona '0' à esquerda se comprimento for 10
    .refine(str => str.length === 11, {
    message: 'Deve ter exatamente 11 dígitos após transformações',
});
exports.PaymentBtgSheetSchema = sheet_1.BasePaymentSchema.extend({
    cpf_or_cnpj: validateCpf,
    transfer: sheet_1.BasePaymentSchema.shape.transfer.extend({
        bank_code: zod_1.z.string().refine(v => v === back_code_1.BANK_CODES.btg, 'O código do banco é inválido'),
    }),
});
exports.btgSheetContext = sheet_1.BaseSheetContext.extend({
    type: zod_1.z.literal(payment_config_types_1.PaymentOptionTypes.BTG_SHEET),
});
exports.btgSheetRequestSchema = zod_1.z.object({
    payments: zod_1.z.array(exports.PaymentBtgSheetSchema).min(1),
    context: exports.btgSheetContext,
});
